import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase'; // juster importsti om nødvendig

function DebugEssensCheck() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkEssens = async () => {
      const authUsers = [];
      const querySnapshot = await getDocs(collection(db, 'essens'));

      querySnapshot.forEach((docSnap) => {
        authUsers.push({
          uid: docSnap.id,
          data: docSnap.data(),
        });
      });

      // Hent alle brukere fra auth (bruker dummy UIDs for eksempel her)
      const knownUIDs = authUsers.map((u) => u.uid);

      setResults(authUsers.map((user) => ({
        uid: user.uid,
        kjennetegn: user.data.kjennetegn || '(ukjent)',
        harEssens: true,
      })));

      setLoading(false);
    };

    checkEssens();
  }, []);

  if (loading) return <p>⏳ Sjekker Firestore...</p>;

  return (
    <div style={{ padding: '1rem' }}>
      <h2>🧪 Debug: Brukere med lagret Kode-Essens™</h2>
      <ul>
        {results.map((r, index) => (
          <li key={index} style={{ marginBottom: '1rem' }}>
            <strong>UID:</strong> {r.uid}<br />
            <strong>Kjennetegn:</strong> {r.kjennetegn}<br />
            <strong>✅ Har essens:</strong> {r.harEssens ? 'Ja' : 'Nei'}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DebugEssensCheck;
